module.exports = __webpack_public_path__ + "static/img/xx_pic5.eeab67b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic5.jpg
// module id = VDBU
// module chunks = 5